import { render } from "./Button4.vue?vue&type=template&id=66d3cd00"
import script from "./Button4.vue?vue&type=script&lang=js"
export * from "./Button4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__